import React from "react";
import { Link } from "react-router-dom";
import { AssetConfig } from "../utils/assets";
import "./HowItWorks.css";

const HowItWorks = () => {
  return (
    <div className="how-it-works">
      {/* Hero Section */}
      <section className="about-banner">
        <div className="container">
          <div className="row">
            <div className="col-md-6 align-self-center">
              <h1>How Dive-in Panels works?</h1>
              <p>
                When we promise you can{" "}
                <Link to="/about-us">make easy money online</Link>, it is no BS.
                We mean every word.
              </p>
              <br />
              <p>
                You are only 3 super-quick steps away from earning money through
                surveys. Follow further and enjoy more fun with a growing kitty.
              </p>
            </div>
            <div className="col-md-6 d-flex justify-content-end align-self-center">
              <figure>
                <img
                  alt="How Dive-in Panels Works?"
                  src={AssetConfig.images.features.onlineArticle}
                />
              </figure>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Steps Section */}
      <section className="market-research">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="page-title text-center">HOW IT WORKS</h2>
              <p className="text-center how-text">
                Want to make money?
                <br />
                You just need to follow these simple steps to get started with
                Dive-in Panels
              </p>
            </div>
          </div>
        </div>

        {/* Steps Timeline */}
        <div className="op-step">
          <div className="container">
            {/* Step 1 */}
            <div className="row steps">
              <div className="col-md-6">
                <div className="step st-pr">
                  <div className="step-inner">
                    <div className="step-header">
                      <figure>
                        <img
                          alt="Register with Dive-in Panels"
                          src="/assets/images/dashboard/step1.png"
                        />
                      </figure>
                      <h4>Register with Dive-in Panels</h4>
                    </div>
                    <div className="stepper-card">
                      <p>Create your profile using any email address, Gmail.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6"></div>
            </div>

            {/* Step 2 */}
            <div className="row steps">
              <div className="col-md-6"></div>
              <div className="col-md-6">
                <div className="step st-pl">
                  <div className="step-inner">
                    <div className="step-header">
                      <figure>
                        <img
                          alt="Complete your Profile"
                          src="/assets/images/dashboard/step2.png"
                        />
                      </figure>
                      <h4>
                        Complete your Profile by Answering Predefined Questions
                      </h4>
                    </div>
                    <div className="stepper-card">
                      <p>
                        Answer all the mandatory questions to start with the
                        surveys. The more optional parts you answer, the higher
                        would be your rewards.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Step 3 */}
            <div className="row steps">
              <div className="col-md-6">
                <div className="step st-pr">
                  <div className="step-inner">
                    <div className="step-header">
                      <figure>
                        <img
                          alt="Take the Online Surveys"
                          src="/assets/images/dashboard/step3.png"
                        />
                      </figure>
                      <h4>Take the Online Surveys</h4>
                    </div>
                    <div className="stepper-card">
                      <p>
                        Access the surveys from your dashboard. Or hop on to the
                        registered email address to find new polls. We curate
                        surveys, especially for you, based on your interests.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6"></div>
            </div>

            {/* Step 4 */}
            <div className="row steps">
              <div className="col-md-6"></div>
              <div className="col-md-6">
                <div className="step st-pl">
                  <div className="step-inner">
                    <div className="step-header">
                      <figure>
                        <img
                          alt="Earn Money from Online Surveys"
                          src="/assets/images/dashboard/step4.png"
                        />
                      </figure>
                      <h4>Hurray! You just earned.</h4>
                    </div>
                    <div className="stepper-card">
                      <p>
                        Yes. Your reward points instantly start accumulating
                        once you finish the first survey. Keep going and within
                        a short time, skyrocket your profits.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Step 5 */}
            <div className="row steps">
              <div className="col-md-6">
                <div className="step st-pr">
                  <div className="step-inner">
                    <div className="step-header">
                      <figure>
                        <img
                          alt="Earn Reward Points and Gifts"
                          src="/assets/images/dashboard/step5.png"
                        />
                      </figure>
                      <h4>From reward points to gifts</h4>
                    </div>
                    <div className="stepper-card">
                      <p>
                        Redeem reward points into desired gift cards. Get your
                        favorite brands in your wallet now. Or cash points in
                        via globally trusted online wallet transfers.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6"></div>
            </div>

            {/* Step 6 */}
            <div className="row steps">
              <div className="col-md-6"></div>
              <div className="col-md-6">
                <div className="step st-pl">
                  <div className="step-inner">
                    <div className="step-header">
                      <figure>
                        <img
                          alt="Refer and Earn"
                          src="/assets/images/dashboard/step6.png"
                        />
                      </figure>
                      <h4>Refer and earn</h4>
                    </div>
                    <div className="stepper-card">
                      <p>
                        Refer Dive-in Panels to your folks and score additional
                        reward points. You grow more when they earn money from
                        surveys. Easy-peasy to explode your gains. You might win
                        a surprise, too!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* PS Section */}
        <div className="col-md-12">
          <div className="stepper-card ps">
            <p className="m-0">
              Don't let the chance slip. Start earning today.
            </p>
          </div>
        </div>

        {/* Join Us Button */}
        <div className="col-md-12">
          <Link
            to="/auth/register"
            className="btn get-started mx-auto d-block mt-5 bordered-btn"
            tabIndex="0"
          >
            Join Us Now
          </Link>
        </div>
      </section>
    </div>
  );
};

export default HowItWorks;
